// ─── 품질 점수 바 ─────────────────────────────────────────────────────────────
import React from 'react';
import { judge } from '../../utils/formatters';

export default function ScoreBar({ score, compact }) {
  if (score == null) return null;

  const j = judge(score);
  const w = compact ? 'w-10' : 'w-14';
  return (
    <div className="flex items-center gap-2">
      <div className={`h-2 ${w} overflow-hidden rounded-full bg-slate-100`}>
        <div
          className={`h-full rounded-full ${j.bar}`}
          style={{ width: `${Math.min(100, score)}%` }}
        />
      </div>
      <span className={`font-mono text-xs font-bold ${j.text}`}>{score}</span>
    </div>
  );
}
